import React from 'react';

// Prominent ETA pill shown below the driver card while the driver is on the
// move - first towards our store, then towards the customer. `eta` is Google's
// duration text, e.g. "1 min" / "12 mins".
const EstimatedTime = ({ eta, label = 'Arriving in' }) => {
  if (!eta) return null;

  return (
    <div className="se-flex se-items-center se-justify-center">
      <div className="se-flex se-items-center se-gap-2 se-px-5 se-py-2.5 se-rounded-full se-bg-green-50 se-border se-border-green-200 se-shadow-sm">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="se-w-5 se-h-5 se-text-green-600"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <circle cx="12" cy="12" r="9" />
          <path d="M12 7v5l3 2" />
        </svg>
        <span className="se-text-base se-font-medium se-text-gray-700">
          {label}{' '}
          <span className="se-font-bold se-text-green-700">{eta}</span>
        </span>
      </div>
    </div>
  );
};

export default EstimatedTime;
